import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Cushion, Grid, LinearGradient, Rectangle, Space, Typography } from '@pitchero/react-ui';
import ClubLink from '../club-link';
import StripedBar from '../striped-bar';
import { fetchMatchUpdates, viewMatchUpdates } from '../../store/teams/match-centre/actions';
import { getUpdateCount } from '../../store/teams/match-centre/selectors';
import { Trans } from '../../lib/i18n';

const LiveUpdateBar = ({ clubId, fixtureId, loadUpdates, teamId, updateCount, viewUpdates }) => {
  const [pollingInterval, setPollingInterval] = useState();
  const hasUpdates = updateCount > 0;

  useEffect(() => {
    if (!pollingInterval) {
      // On mount, check for updates and set up polling for every 30 seconds
      loadUpdates(clubId, teamId, fixtureId);
      setPollingInterval(setInterval(() => loadUpdates(clubId, teamId, fixtureId), 30000));
    }
  }, []);

  return (
    <Space bottom="large">
      <Rectangle radius="rounded" fill="mercury">
        <LinearGradient
          component="div"
          key={`${fixtureId}-${updateCount}`}
          angle={90}
          stops={
            hasUpdates
              ? [
                  [0, '#F15E64'],
                  [100, '#F67D82'],
                ]
              : []
          }
        >
          <Cushion vertical="small" horizontal="medium">
            <Grid columns="auto 1fr auto" alignItems="center">
              <div>
                <Cushion horizontal="xxsmall">
                  <Rectangle
                    fill="white"
                    radius="circle"
                    style={{ display: 'inline-block', minWidth: '1em' }}
                  >
                    <Typography
                      preset="name"
                      color={hasUpdates ? 'outcomeBgL' : 'black'}
                      align="center"
                    >
                      {updateCount}
                    </Typography>
                  </Rectangle>
                </Cushion>
              </div>
              <Cushion horizontal="medium">
                <Typography preset="subtitle--small" color={hasUpdates ? 'white' : 'black'}>
                  <Trans
                    i18nKey={hasUpdates ? 'pending_match_updates_label' : 'no_match_updates_label'}
                  >
                    {hasUpdates ? 'New live updates!' : 'Waiting for live updates'}
                  </Trans>
                </Typography>
              </Cushion>
              {hasUpdates && (
                <Typography color="white" component="div" preset="button">
                  <ClubLink
                    route="team.match_centre.events"
                    params={{ teamId, fixtureId }}
                    replace
                    scroll={false}
                  >
                    <span
                      role="presentation"
                      onClick={() => viewUpdates(teamId, fixtureId)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Trans i18nKey="common:view">View</Trans>
                    </span>
                  </ClubLink>
                </Typography>
              )}
            </Grid>
          </Cushion>
          <StripedBar foreground={hasUpdates ? '#FFFFFF5F' : '#0000000F'} />
        </LinearGradient>
      </Rectangle>
    </Space>
  );
};

LiveUpdateBar.propTypes = {
  clubId: PropTypes.number.isRequired,
  fixtureId: PropTypes.string.isRequired,
  loadUpdates: PropTypes.func.isRequired,
  teamId: PropTypes.number.isRequired,
  updateCount: PropTypes.number.isRequired,
  viewUpdates: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  updateCount: getUpdateCount(state, ownProps.teamId, ownProps.fixtureId),
});

export default connect(mapStateToProps, {
  loadUpdates: fetchMatchUpdates,
  viewUpdates: viewMatchUpdates,
})(LiveUpdateBar);
